/* unplugin-vue-components disabled */import { render } from "./diyPage.vue?vue&type=template&id=dd6d7762&scoped=true"
import script from "./diyPage.vue?vue&type=script&lang=js"
export * from "./diyPage.vue?vue&type=script&lang=js"

import "./diyPage.vue?vue&type=style&index=0&id=dd6d7762&scoped=true&lang=css"

import exportComponent from "E:\\projects\\git\\company\\www_dixiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6d7762"]])

export default __exports__